<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XjGzvZ/tc-custom/9781504061643.jpg?1702065248319" alt="This image is the cover for the book Christmas Carol"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas Carol
      </h1>
      <p class="bookDescription body article font2">
        <b>The story of a miser’s transformation, and the most beloved Christmas novel of all time.</b><br/>  <br/> An immediate bestseller in the mid-nineteenth century and praised by the <i>Illustrated London News </i>for its “playful and sparkling humor [and] gentle spirit of humanity,” Charles Dickens’s <i>A Christmas Carol </i>has remained continuously in print for more than one hundred years, a cherished part of the holiday season for millions of readers.<br/>  <br/> The novel follows Ebenezer Scrooge, a rich man who has no patience for the merriment of the holidays and prefers counting his money to counting his blessings . . . until a series of spectral visitors awaken the Christmas spirit in his heart. Both a spine-tingling ghost story and a historical portrait of poverty and greed in Victorian England, <i> A Christmas Carol</i> is a delightful classic for readers young and old.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Dickens
      </h2>
      
      <p class="authorDescription body article">An international celebrity during his lifetime, Charles Dickens (1812&shy;&ndash;1870) is widely regarded as the greatest novelist of the Victorian era. His classic works include&#160;<I>A Christmas Carol</I>,&#160;<I>Oliver Twist</I>,&#160;<I>David Copperfield</I>,&#160;<I>Great Expectations</I>, and&#160;<I>A Tale of Two Cities</I>, one of the bestselling novels of all time. When Dickens was twelve years old, his father was sent to debtors&rsquo; prison, and the boy was forced to work in a boot-blacking factory to support his family. The experience greatly shaped both his fiction and his tireless advocacy for children&rsquo;s rights and social reform.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ef3f54e